import Masonry from 'masonry-layout';

async function waitForImages(container: HTMLElement): Promise<unknown> {
	const images = Array.from(container.querySelectorAll('img'));
	if (images.length === 0) {
		return Promise.resolve();
	}

	return Promise.all(
		images.map((img) => {
			if (img.complete && img.naturalHeight !== 0) {
				return Promise.resolve();
			}
			return new Promise((resolve) => {
				img.addEventListener('load', resolve);
				img.addEventListener('error', resolve);
			});
		})
	);
}

document.addEventListener('DOMContentLoaded', () => {
	const masonry = document.querySelector<HTMLElement>('.media-gallery__masonry');
	if (!masonry) {
		return;
	}

	waitForImages(masonry).then(() => {
		new Masonry(masonry, {
			itemSelector: '.media-gallery__item',
			columnWidth: '.media-gallery__item',
			gutter: '.media-gallery__masonry-gutter',
			percentPosition: true,
		});
	});
});
